<vm-article [content]="content"></vm-article>
